export default "__VITE_ASSET__DEDew16___"